import Decimal from 'decimal.js';
import dayjs from 'dayjs';
import { useQuery } from 'react-query';

import { DTRRuleConverted } from '../../types';

import { convertArrayToObjectByKey } from '../utils/convertArrayToObjectByKey';

import { getDTRRule } from 'RestAPIs/dtrRules';

export const useGetDetails = (rowId: number) =>
  useQuery(['DTRRules', 'details', rowId], () =>
    getDTRRule(rowId).then<DTRRuleConverted>((response) => ({
      ...response.data,
      rules: convertArrayToObjectByKey(
        response.data.variables.map(({ value, ruleVariableName, type }) => ({
          type,
          ruleVariableName,
          value:
            typeof value === 'number' && type === 'double'
              ? new Decimal(value).toDecimalPlaces(2).toNumber() // mandatory for displaying correct value
              : typeof value !== 'number' && dayjs(value).isValid()
              ? dayjs(value).toDate()
              : value
        })),
        'ruleVariableName'
      )
    }))
  );
